// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { Modal } from "react-bootstrap";
import FilesUploader from "../../common/filesUploader/filesUploader";
import { strings } from "../../../../common/strings";
import { IImpersonation } from "../../../../models/applicationState";

/**
 * Properties for Editor Side Bar
 * @member assets - Array of assets to be previewed
 * @member onAssetSelected - Function to call when asset from side bar is selected
 * @member selectedAsset - Asset initially selected
 * @member thumbnailSize - The size of the asset thumbnails
 */
export interface IAddFileModalProps {
    showModal: boolean;
    projectId: string;
    authToken: string;
    impersonation: IImpersonation;
    closeUploadModal: () => void;
    onFileUpload: () => void;
}

/**
 * State for Editor Side Bar
 * @member selectedAsset - Asset selected from side bar
 */
export interface IAddFileModalState {
    visible: boolean;
}

/**
 * @name - Editor Side Bar
 * @description - Side bar for editor page
 */
export default class AddFileModal extends React.Component<IAddFileModalProps, {}> {
    public state: IAddFileModalState = {
        visible: false,
    };

    public render() {
        return (
            <>
                <Modal
                    show={this.props.showModal}
                    onHide={this.props.closeUploadModal}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{strings.editorPage.uploadDocument}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FilesUploader
                            onFileUpload={this.props.onFileUpload}
                            projectId={this.props.projectId}
                            authToken={this.props.authToken}
                            impersonation={this.props.impersonation}
                        />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
